"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchConfirmOrderAsGuest = exports.fetchConfirmOrder = exports.validateNIT = exports.fetchValidate3DSPayment = exports.fetchProcess3DSPayment = exports.fetchOrderValidation = exports.fetchIsRiskyCustomerAsGuest = exports.fetchIsRiskyCustomer = exports.fetchCVVAuthorization = exports.fetchOrderTracker = exports.fetchGetCartTotalPrices = void 0;

var _tslib = require("tslib");

var _api = require("../api");

var fetchGetCartTotalPrices = function fetchGetCartTotalPrices(checkoutRequest) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.post("v2"
      /* Checkout */
      + "/" + "checkout"
      /* Checkout */
      , checkoutRequest).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchGetCartTotalPrices = fetchGetCartTotalPrices;

var fetchOrderTracker = function fetchOrderTracker(uniqueOrderNumber) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.get("v1"
      /* OrderTracker */
      + "/" + "order"
      /* OrderTracker */
      + "/" + uniqueOrderNumber + "/track").then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchOrderTracker = fetchOrderTracker;

var fetchCVVAuthorization = function fetchCVVAuthorization(cvvRequest) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.post("cvvCheckoutAuthorization"
      /* CVVAuthorization */
      , cvvRequest).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchCVVAuthorization = fetchCVVAuthorization;

var fetchIsRiskyCustomer = function fetchIsRiskyCustomer(isRiskyCustomer) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.post("IsRiskyCustomer"
      /* IsRiskyCustomer */
      , isRiskyCustomer).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchIsRiskyCustomer = fetchIsRiskyCustomer;

var fetchIsRiskyCustomerAsGuest = function fetchIsRiskyCustomerAsGuest(isRiskyCustomerAsGuest) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.post("IsRiskyCustomerAsGuest"
      /* IsRiskyCustomerAsGuest */
      , isRiskyCustomerAsGuest).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchIsRiskyCustomerAsGuest = fetchIsRiskyCustomerAsGuest;

var fetchOrderValidation = function fetchOrderValidation(orderValidationRequest) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.post("orderValidation"
      /* OrderValidation */
      , orderValidationRequest).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchOrderValidation = fetchOrderValidation;

var fetchProcess3DSPayment = function fetchProcess3DSPayment(paymentRequest) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.post("process3DSPayment"
      /* Process3DSPayment */
      , paymentRequest).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchProcess3DSPayment = fetchProcess3DSPayment;

var fetchValidate3DSPayment = function fetchValidate3DSPayment(paymentRequest) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.post("validate3DSPayment"
      /* Validate3DSPayment */
      , paymentRequest).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchValidate3DSPayment = fetchValidate3DSPayment;

var validateNIT = function validateNIT(validateRequest) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.post("v1"
      /* ValidateNIT */
      + "/" + "validateNIT"
      /* ValidateNIT */
      , validateRequest).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.validateNIT = validateNIT;

var fetchConfirmOrder = function fetchConfirmOrder(confirmOrderRequest) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.post("v2"
      /* ConfirmOrder */
      + "/" + "confirmOrder"
      /* ConfirmOrder */
      , confirmOrderRequest).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchConfirmOrder = fetchConfirmOrder;

var fetchConfirmOrderAsGuest = function fetchConfirmOrderAsGuest(confirmOrderAsGuestRequest) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.post("v2"
      /* ConfirmOrderAsGuest */
      + "/" + "confirmOrderAsGuest"
      /* ConfirmOrderAsGuest */
      , confirmOrderAsGuestRequest).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchConfirmOrderAsGuest = fetchConfirmOrderAsGuest;